module.exports = require("next/dist/experimental/testmode/server-edge");